export class IntegrationApiKeys {
    public url: string;
    public apiKey: string;
    public id: string;
    public clientId: string;
    public clientSecret: string
    public authorizationCode: string;
    public timestamp: string;
    public place: string;
    public hash: string;

    public constructor(data?: any) {
        this.url = (data && data.url) ? data.url : '';
        this.apiKey = (data && data.apiKey) ? data.apiKey : '';
        this.id = (data && data.id) ? data.id: '';
        this.clientId = (data && data.clientId) ? data.clientId : '';
        this.clientSecret = (data && data.clientSecret) ? data.clientSecret : '';
        this.authorizationCode = (data && data.authorizationCode) ? data.authorizationCode : '';
        this.timestamp = (data && data.timestamp) ? data.timestamp : '';
        this.place = (data && data.place) ? data.place : '';
        this.hash = (data && data.hash) ? data.hash : '';
    }
}
